/*
 * @Description:可用于各模块定义各自api请求
 * @Author: gonghong
 * @Date: 2024-02-20 09:46:51
 * @LastEditTime: 2024-02-20 10:59:40
 */
import axiosRequest from './request'
class Api{
    // 请求url
    url = ''
    // 请求方法
    method = ''
    /**
     * @description: 构造函数
     * @param {*} url 请求url
     * @param {*} method 请求方法
     * @return {*}
     */
    constructor(url, method){
        this.url = url
        this.method = method
    }
    /**
     * @description: 请求对应的url
     * @param {*} params 请求该api的参数
     * @param {*} headers
     * @param {*} options
     * @return {*}
     */
    request(params, headers, options){
        return axiosRequest.send(this, params, headers, options)
    }
    /**
     * @description: 静态工厂，返回Api对象，并设置url与method属性
     * @param {*} url url
     * @param {*} method 请求方法(get,post,put,delete...)
     * @return {*}
     */
    static create(url, method){
        return new Api(url, method)
    }
    /**
      * @description: get请求
      * @param {*} url 请求URL
      * @return {*}
      */
    static newGet(url){
        return Api.create(url, 'get')
    }
    /**
      * @description: POST请求
      * @param {*} url 请求URL
      * @return {*}
      */
    static newPost(url){
        return Api.create(url, 'post')
    }
    /**
     * @description: put请求
     * @param {*} url 请求URL
     * @return {*}
     */
    static newPut(url){
        return Api.create(url, 'put')
    }
    /**
     * @description: delete请求
     * @param {*} url 请求URL
     * @return {*}
     */
    static newDelete(url){
        return Api.create(url, 'delete')
    }
}
export default Api
